"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiBreadcrumbs = getMuiBreadcrumbs;
function getMuiBreadcrumbs(palette) {
  return {
    defaultProps: {
      // @ts-ignore missing in defaultProps type
      'data-testid': 'required',
      itemsBeforeCollapse: 3,
      maxItems: 5
    },
    styleOverrides: {
      root: {
        '.MuiBreadcrumbs-li': {
          '.MuiLink-root': {
            '&:hover': {
              background: palette.common.white
            },
            color: palette.primary[900]
          },
          '> *': {
            fontSize: 14,
            fontWeight: 400
          }
        },
        '.MuiBreadcrumbs-separator': {
          '.MuiSvgIcon-root': {
            height: '18px',
            width: '18px'
          },
          margin: 0
        },
        '.MuiButtonBase-root': {
          '&:hover': {
            background: palette.common.white
          },
          '> *': {
            fontSize: 14,
            fontWeight: 400
          },
          backgroundColor: palette.common.white,
          color: palette.primary[900],
          margin: 0,
          paddingTop: 8
        }
      }
    }
  };
}